define('areas/organizationmanager/commands/directloginorgcommand',["require", "exports", "services/trace", "services/httpclient"], function (require, exports, Trace, Http) {
    "use strict";
    var DirectLoginOrgCommand = (function () {
        function DirectLoginOrgCommand() {
        }
        DirectLoginOrgCommand.prototype.execute = function (organization) {
            try {
                var httpClient = new Http.Channel();
                var action = "/api/organization/getdirectlogin?organizationId=";
                httpClient.getData(action + organization.id + "&organizationType=" + organization.organizationType + "&isMagic=false", Http.ServiceTarget.portalApi).
                    then(function (data) {
                    window.open(data, "_blank");
                }).fail(function (error) {
                    Trace.traceError(error.responseJSON.Message, null, "organizationmanager:index", true);
                });
                return true;
            }
            catch (exception) {
                Trace.traceError(exception, null, "organizationmanager:index", true);
            }
        };
        return DirectLoginOrgCommand;
    }());
    return DirectLoginOrgCommand;
});

